import { TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import CustomTextField from '../components/customTextField';

export default function EditFAQ(props) {
    const editorRef = useRef();
    const location = useLocation()
    const history = useHistory()
    const [content, setContent] = useState("")
    const [listTipe] = useState([
        { value: 'Mobile' },
        { value: 'KIOSK' },
    ])
    const [listKategori, setListKategori] = useState([])
    const [judul, setJudul] = useState("")
    const [id, setID] = useState("")
    const [pickType, setPickType] = useState(null)
    const [pickCategory, setPickCategory] = useState(null)

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        // Get underlining core object here
        // Notice that useEffect is been used because you have to make sure the editor is rendered.
        console.log(editorRef.current.editor.core);
        // console.log(location);
        getDetail()
    }, []);

    const handleImageUploadBefore = (files, info, uploadHandler) => {
        // uploadHandler is a function
        console.log(files, info, uploadHandler)
        try {
            ResizeImage(files, uploadHandler)
        } catch (err) {
            uploadHandler(err.toString())
        }
    }
    const handleImageUpload = (targetImgElement, index, state, imageInfo, remainingFilesCount) => {
        console.log(targetImgElement, index, state, imageInfo, remainingFilesCount)
    }

    const handleImageUploadError = (errorMessage, result) => {
        console.log(errorMessage, result)
    }

    const handleEditorChange = (value) => {
        // console.log(value);

        setContent(value)
    }

    const handleDrop = (event) => {
        console.log(event); //Get the drop event
    }

    const handleBlur = (event, editorContents) => {
        // console.log(event, editorContents); //Get the blur event
    }

    const imageUploadHandler = (xmlHttpRequest, info, core) => {
        console.log(xmlHttpRequest, info, core)
    }

    const ResizeImage = (files, uploadHandler) => {
        const uploadFile = files[0];
        const img = document.createElement('img');
        const canvas = document.createElement('canvas');
        const reader = new FileReader();

        reader.onload = function (e) {
            img.src = e.target.result
            img.onload = function () {
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                const MAX_WIDTH = 200;
                const MAX_HEIGHT = 100;
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(function (blob) {
                    uploadHandler([new File([blob], uploadFile.name)])
                }, uploadFile.type, 1);
            }
        }

        reader.readAsDataURL(uploadFile);
    }

    const getDetail = (cat) => {
        api.create().getDetailFAQ(location.state.id[4]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    let idTipe = listTipe.findIndex((val) => val.value === data.category_type)
                    console.log(idTipe);
                    if (idTipe > -1) {
                        setPickType(listTipe[idTipe])
                        getKategori(listTipe[idTipe], data.category)
                    }
                    setID(data.id)
                    setContent(data.description)
                    setJudul(data.title)
                    forceUpdate()
                }
            }
        })
    }

    const getKategori = (tipe, cat) => {
        api.create().getCategoryFAQByType(tipe.value).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item) => {
                        data.push({
                            id: item.id,
                            value: item.category
                        })
                    })
                    let idCat = data.findIndex((val) => val.value === cat)
                    console.log(idCat);
                    if (idCat > -1) {
                        setPickCategory(data[idCat])
                    }
                    setListKategori(data)
                    forceUpdate()
                    // getDetail(data)
                }
            }
        })
    }

    const handleSave = () => {
        let payload = {
            "faq_id": id,
            "category_id": pickCategory.id,
            "title": judul,
            "description": content
        }
        api.create().updateFAQ(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    history.goBack()
                }
            }
        })
    }

    return (
        <div style={{ maxHeight: props.height - 80, width: '100%', overflow: 'scroll', padding: '20px 0px' }}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '100%' }}>
                    <Typography style={{ color: 'black', fontWeight: '500', fontSize: 20, fontFamily: 'Poppins' }}>Edit Data FAQ</Typography>
                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Tipe</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <Autocomplete
                            options={listTipe}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            id="tipe"
                            style={{ width: '60%' }}
                            onChange={(event, newInputValue) => {
                                setPickType(newInputValue)
                                setPickCategory(null)
                                forceUpdate()
                                getKategori(newInputValue)
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                // label="Alasan Ditunda"
                                />
                            }
                            value={pickType}
                        />
                    </div>
                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '30%' }}>Kategori</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <Autocomplete
                            options={listKategori}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            id="tipe"
                            style={{ width: '60%' }}
                            onChange={(event, newInputValue) => {
                                setPickCategory(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                // label="Alasan Ditunda"
                                />
                            }
                            value={pickCategory}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ display: 'flex', alignItems: 'center', color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Judul</Typography>
                        <Typography style={{ display: 'flex', alignItems: 'center', color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <div style={{ width: '60%', margin: 0 }}>
                            <CustomTextField
                                value={judul}
                                onChange={(val) => {
                                    setJudul(val)
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <SunEditor
                            showToolbar={true}
                            enableToolbar={true}
                            ref={editorRef}
                            width={"100%"}
                            setOptions={{
                                width: '100%',
                                height: 200,
                                buttonList: [
                                    // default
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['paragraphStyle', 'blockquote'],
                                    ['fontColor', 'hiliteColor', 'textStyle'],
                                    ['bold', 'underline', 'italic', 'list', 'align'],
                                    ['table', 'link', 'image'],
                                    ['fullScreen']
                                ]
                                // buttonList: buttonList.formatting // Or Array of button list, eg. [['font', 'align'], ['image']]
                                // Other option
                            }}
                            onChange={handleEditorChange}
                            setContents={content}
                            onDrop={handleDrop}
                            imageUploadHandler={imageUploadHandler}
                            onBlur={handleBlur}
                            onImageUploadBefore={handleImageUploadBefore}
                            onImageUpload={handleImageUpload}
                            onImageUploadError={handleImageUploadError}
                        />
                    </div>
                </div>
            </div>
            {/* <SunEditor
                setContents={content}
                disable={true}
                enableToolbar={false} showToolbar={false} width="100%" height="100%" setOptions={{ resizingBar: false, showPathLabel: false }} /> */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                <div
                    style={{ backgroundColor: '#2a9c6c', width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                    onClick={() => {
                        handleSave()
                        console.log(content);
                        console.log(String(content).indexOf("*"));
                    }}>
                    <Typography style={{ color: 'white' }}>Simpan</Typography>
                </div>
            </div>
        </div>
    )
}